import { Box, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { FC, useState } from "react";
import useResponsive from "../../hooks/useResponsive";
import CandidateDetails from "./Candidate_details";
import { CandidateDetailsProps } from "../../interface/application";

const CandidateContent: FC<{ candidate_info: CandidateDetailsProps }> = ({
  candidate_info,
}) => {
  
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");

  return (
    <Stack sx={{ paddingX: 2 }}>
      <Box
        sx={{
          margin: 2,
          padding: isMedium ? 3 : 4,
          borderRadius: "3px",
          minHeight: "60vh",
          backgroundColor: theme.palette.common.white,
        }}
      >
        <CandidateDetails candidate_info={candidate_info} />
      </Box>
    </Stack>
  );
};

export default CandidateContent;
